<template>
    <DCard
        padding
        :title="__('settings.legal_forms.name')"
    >
        <DRow>
            <DCol>
                <DTable
                    class="table-responsive"
                    :items="legalForms.data"
                    :fields="fields"
                    hover
                >
                    <template #actions="{item}">
                        <td class="text-right">
                            <DDropdown
                                :id="`actions_dropdown_${item.tld}_${item.product_id}`"
                                :class="'more-actions-button'"
                                :caret="false"
                                icon="dots-horizontal"
                            >
                                <DDropdownItem
                                    icon="pencil"
                                    mini
                                    @click="openEditModal(item)"
                                >
                                    {{ __('settings.legal_forms.buttons.edit') }}
                                </DDropdownItem>
                                <DDropdownItem
                                    icon="trash-can-outline"
                                    mini
                                    @click="handleDeleteButton(item)"
                                >
                                    {{ __('settings.legal_forms.buttons.delete') }}
                                </DDropdownItem>
                            </DDropdown>
                        </td>
                    </template>
                </DTable>
                <DPagination
                    v-if="legalForms.last_page > 1"
                    :active-page="legalForms.current_page"
                    :pages="legalForms.last_page"
                    align="center"
                    @update:activePage="changePage"
                />
            </DCol>
        </DRow>
        <DModal
            v-model:show="showDeleteModal"
            :title="__('settings.legal_forms.modal.delete_confirm_modal.title')"
            :message="__('settings.legal_forms.modal.delete_confirm_modal.message')"
            is-confirm
            is-error
            @close="showDeleteModal = false"
            @confirm="deleteItem"
        />
        <CreateModal
            v-if="showCreateModal"
            v-model:show="showCreateModal"
            :legal-form="selectedItem"
            :is-create="selectedItem === null"
            @close-modal="closeCreateModal"
        />
        <DFabs>
            <DFab
                icon="plus"
                :label="__('settings.legal_forms.buttons.create')"
                @click="openCreateModal"
            />
        </DFabs>
    </DCard>
</template>

<script>
import App from '~@/App.vue'
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import LovLayout from '~@/Pages/Settings/Lov/LovLayout.vue'
import { __ } from '~@/Composables/translation'
import CreateModal from '~@/Components/Settings/LegalForms/CreateModal'

export default {
    layout: [App, LovLayout]
}
</script>

<script setup>
defineProps({
    legalForms: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

const showDeleteModal = ref(false)
const showCreateModal = ref(false)

const fields = [
    { key: 'name', label: __('settings.legal_forms.form.name'), sorter: false },
    { key: 'actions', sorter: false, label: '', _style: { minWidth: '5%' } }
]

const selectedItem = ref(null)

const deleteItem = () => router.delete(route('settings.legal-forms.destroy', { legal_form: selectedItem.value.id }))

const changePage = (page) => {
    const queryParameters = {}

    if (page > 1) {
        queryParameters.page = page
    }

    router.get(route('settings.legal-forms.index'), queryParameters)
}

function handleDeleteButton (item) {
    selectedItem.value = item
    showDeleteModal.value = true
}

function openEditModal (item) {
    selectedItem.value = item
    showCreateModal.value = true
}

function openCreateModal () {
    showCreateModal.value = true
}

function closeCreateModal () {
    selectedItem.value = null
    showCreateModal.value = false
}
</script>
